// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import Img from  '../assets/logo.png'; // Adjust the path to your logo image

// const Verify = ({ onClose, onSubmit }) => {
//   const handleSubmit = () => {
//     onSubmit(); // Call the function passed via props to open the login form
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
//       onClick={onClose}
//     >
//       <div
//         className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-[350px]"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="relative mb-4 flex justify-center">
//           <img
//             src={Img}
//             alt="Biotech Maali Logo"
//             className="w-auto h-[92px]"
//           />
//           <button
//             onClick={onClose}
//             className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
//           >
//             <FontAwesomeIcon icon={faTimes} size="lg" />
//           </button>
//         </div>
//         <h2 className="text-center text-lg font-semibold mb-6">
//           Enter verification code
//         </h2>
//         <div className="flex justify-center mb-4 space-x-2">
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//         </div>
//         <div className="flex justify-between mb-6">
//           <button className="text-[#FF9630] text-sm font-medium ">Resend</button>
//         </div>
//         <button
//           onClick={handleSubmit}
//           className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//         >
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Verify; 

// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import Img from "../assets/logo.png"; // Adjust the path to your logo image

// const Verify = ({ onClose, onSubmit }) => {
//   const handleSubmit = () => {
//     onSubmit(); // Call the function passed via props to open the login form
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
//       onClick={onClose}
//     >
//       <div
//         className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-[350px]"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="relative mb-4 flex justify-center">
//           <img src={Img} alt="Biotech Maali Logo" className="w-auto h-[92px]" />
//           <button
//             onClick={onClose}
//             className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
//           >
//             <FontAwesomeIcon icon={faTimes} size="lg" />
//           </button>
//         </div>
//         <h2 className="text-center text-lg font-semibold mb-6">
//           Enter verification code
//         </h2>
//         <div className="flex justify-center mb-4 space-x-2">
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//         </div>
//         <div className="flex justify-between mb-6">
//           <button className="ml-auto text-[#FF9630] text-sm font-medium">
//             Resend
//           </button>
//         </div>
//         <button
//           onClick={handleSubmit}
//           className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//         >
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Verify;


// import React from "react";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import Img from "../assets/logo.png"; // Adjust the path to your logo image

// const Verify = ({ onClose }) => {
//   const navigate = useNavigate(); // Initialize the navigation hook

//   const handleSubmit = () => {
//     navigate("/login"); // Replace '/next-page' with your desired route
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
//       onClick={onClose}
//     >
//       <div
//         className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-[350px]"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="relative mb-4 flex justify-center">
//           <img src={Img} alt="Biotech Maali Logo" className="w-auto h-[92px]" />
//           <button
//             onClick={onClose}
//             className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
//           >
//             <FontAwesomeIcon icon={faTimes} size="lg" />
//           </button>
//         </div>
//         <h2 className="text-center text-lg font-semibold mb-6">
//           Enter verification code
//         </h2>
//         <div className="flex justify-center mb-4 space-x-2">
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//           <input
//             type="text"
//             maxLength="1"
//             className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
//           />
//         </div>
//         <div className="flex justify-between mb-6">
//           <button className="ml-auto text-[#FF9630] text-sm font-medium">
//             Resend
//           </button>
//         </div>
//         <button
//           onClick={handleSubmit}
//           className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//         >
//           Submit
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Verify;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Img from "../assets/logo.png"; // Adjust the path to your logo image

const Verify = ({ onClose }) => {
  const navigate = useNavigate(); // Initialize the navigation hook

  // Dummy dataset
  const dummyData = {
    code: "1234", // Example verification code
  };

  // State to manage the verification code inputs
  const [formData, setFormData] = useState({
    code: ["", "", "", ""], // Default to empty values for each input
  });

  // Handle individual input changes
  const handleInputChange = (index, value) => {
    setFormData((prevData) => {
      const updatedCode = [...prevData.code];
      updatedCode[index] = value;
      return { ...prevData, code: updatedCode };
    });
  };

  // Function to handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();

    const formSubmitData = new FormData();
    formSubmitData.append("code", formData.code.join("")); // Join code inputs into a single string

    // Log FormData content for demonstration
    for (const [key, value] of formSubmitData.entries()) {
      console.log(`${key}: ${value}`);
    }

    // Navigate to login after form submission
    navigate("/login");
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-[350px]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative mb-4 flex justify-center">
          <img src={Img} alt="Biotech Maali Logo" className="w-auto h-[92px]" />
          <button
            onClick={onClose}
            className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
          >
            <FontAwesomeIcon icon={faTimes} size="lg" />
          </button>
        </div>
        <h2 className="text-center text-lg font-semibold mb-6">
          Enter verification code
        </h2>
        <form onSubmit={handleFormSubmit}>
          <div className="flex justify-center mb-4 space-x-2">
            {formData.code.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                value={digit}
                onChange={(e) =>
                  handleInputChange(index, e.target.value.replace(/[^0-9]/g, ""))
                }
                className="w-12 h-12 text-center text-xl border-2 border-[#FF9630] rounded-md focus:outline-none focus:ring-2 focus:ring-[#FF9630]"
              />
            ))}
          </div>
          <div className="flex justify-between mb-6">
            <button
              type="button"
              onClick={() =>
                setFormData((prevData) => ({
                  ...prevData,
                  code: dummyData.code.split(""), // Populate inputs with dummy data
                }))
              }
              className="ml-auto text-[#FF9630] text-sm font-medium"
            >
              Resend
            </button>
          </div>
          <button
            type="submit"
            className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Verify;
